// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eT1H","label":"styles_label__1vjiK"};